import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardTeaser } from '../../../shared';

export const FeedCardPost: FunctionComponent<FeedCardProps> = memo((props) => (
  <FeedCardTeaser {...props} />
));
